module.exports = __webpack_public_path__ + "img/10.6b400ac0.jpg";